import React from 'react';
import { ErrorSeverity, LoggerSDK } from './TranquiLogger';
import ErrorPage from '../App/ErrorPage';
import { session } from '../../utils/auth';
import eventsTracking from '../../utils/eventsTracking';

interface ErrorBoundaryProps {
}

interface ErrorBoundaryState {
  hasError: boolean
}

const TranquiLogger = new LoggerSDK();

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
    this.handleGoHome = this.handleGoHome.bind(this);
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    const message = {
      details: {
        error,
        errorInfo,
        enviroment: {
          NODE_ENV: process.env.NODE_ENV,
          REACT_APP_CLIENT_VERSION: process.env.REACT_APP_CLIENT_VERSION,
          REACT_APP_ENV_OVERRIDE: process.env.REACT_APP_ENV_OVERRIDE,
        },
        route: window.location.href,
        userId: session.userId,
      },
      message: 'App crash',
    };
    TranquiLogger.sendMessage(message, ErrorSeverity.error);
    eventsTracking.error.crash(error.stack);
  }

  handleGoHome() {
    this.setState({ hasError: false });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      // You can render any custom fallback UI
      return <ErrorPage onGoHome={this.handleGoHome} />;
    }

    return children;
  }
}

export default ErrorBoundary;
